import React, { useState } from 'react';

// Import images
import backgroundImage1 from '../img/envision/digital/dd/digital1.jpg';
import backgroundImage2 from '../img/envision/digital/dd/digital2.jpg';
import backgroundImage3 from '../img/envision/digital/dd/digital3.jpg';
import backgroundImage4 from '../img/envision/digital/dd/digital4.jpg';
import backgroundImage5 from '../img/envision/digital/dd/digital5.jpg';

// Define the styles as an object
const styles = {
    innovationCaseStudies: {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '40px 0',
        textAlign: 'center',
    },
    container: {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '20px',
    },
    intelliSolutionBlock: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '10px',
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        width: '100%',
        cursor: 'pointer',
        position: 'relative', // To position content over the image
        overflow: 'hidden', // To prevent image from overflowing
        height: '400px', // Increased height for the card (adjust as needed)
    },
    intelliSolutionImage: {
        width: '100%',
        height: '100%', // Set height to 100% so the image covers the full height of the card
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '8px',
        position: 'absolute', // Make the image fill the entire area of the card
        top: '0',
        left: '0',
        opacity:'0.9'
    },
    intelliSolutionImageOverlay: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)', // Increased opacity (0.7 instead of 0.5)
        borderRadius: '8px',
    },
    intelliSolutionDesc: {
        position: 'absolute',
        bottom: '60px',
        left: '20px',
        right: '20px',
        backgroundColor: 'rgba(0, 0, 0, 0.7)', // Increased opacity here as well
        color: '#fff',
        padding: '10px',
        borderRadius: '8px',
        display: 'none',
    },
    h3: {
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#fff',
        position: 'absolute',
        bottom: '60px', // Adjusted position to be over the image
        left: '20px',
        right: '20px',
    },
};

const Digitalimpactdeliverypage = () => {
    // State to manage visibility of card content
    const [visibleContent, setVisibleContent] = useState({
        card1: false,
        card2: false,
        card3: false,
        card4: false,
        card5: false,
    });

    const handleCardClick = (card) => {
        // Toggle visibility of the clicked card content
        setVisibleContent((prev) => ({
            ...prev,
            [card]: !prev[card],
        }));
    };

    return (
        <div className="innovation-case-studies" style={styles.innovationCaseStudies}>
            <div className="container" style={styles.container}>
                <div className="row">
                    {/* Card 1 */}
                    <div className="col-sm-12 col-md-4 mb-4">
                        <div
                            className="intelli-solution-block"
                            style={styles.intelliSolutionBlock}
                            onClick={() => handleCardClick('card1')} // Toggle card1 content
                        >
                            <div
                                className="intelli-solution-image"
                                style={{
                                    ...styles.intelliSolutionImage,
                                    backgroundImage: `url(${backgroundImage1})`,
                                }}
                            />
                            <h3 style={styles.h3}>Our Approach to Business Excellence</h3>
                            {visibleContent.card1 && (
                                <div
                                    className="intelli-solution-desc"
                                    style={{ ...styles.intelliSolutionDesc, display: 'block' }}
                                >
                                    <p>
                                        We follow a three-step approach to business excellence: educate, engage, and evaluate. We educate our associates on the latest process improvements, problem-solving tools, and methodologies, and engage them to apply the learnings in projects and business processes. We also evaluate the performance of delivery units annually and allow them to benchmark best practices both internally and externally.
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Card 2 */}
                    <div className="col-sm-12 col-md-4 mb-4">
                        <div
                            className="intelli-solution-block"
                            style={styles.intelliSolutionBlock}
                            onClick={() => handleCardClick('card2')} // Toggle card2 content
                        >
                            <div
                                className="intelli-solution-image"
                                style={{
                                    ...styles.intelliSolutionImage,
                                    backgroundImage: `url(${backgroundImage2})`,
                                }}
                            />
                            <h3 style={styles.h3}>BEST: Envision’s Business Operating System</h3>
                            {visibleContent.card2 && (
                                <div
                                    className="intelli-solution-desc"
                                    style={{ ...styles.intelliSolutionDesc, display: 'block' }}
                                >
                                    <p>
                                        We follow a three-step approach to business excellence: educate, engage, and evaluate. We educate our associates on the latest process improvements, problem-solving tools, and methodologies, and engage them to apply the learnings in projects and business processes. We also evaluate the performance of delivery units annually and allow them to benchmark best practices both internally and externally.
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Card 3 */}
                    <div className="col-sm-12 col-md-4 mb-4">
                        <div
                            className="intelli-solution-block"
                            style={styles.intelliSolutionBlock}
                            onClick={() => handleCardClick('card3')} // Toggle card3 content
                        >
                            <div
                                className="intelli-solution-image"
                                style={{
                                    ...styles.intelliSolutionImage,
                                    backgroundImage: `url(${backgroundImage3})`,
                                }}
                            />
                            <h3 style={styles.h3}>Quality Management System</h3>
                            {visibleContent.card3 && (
                                <div
                                    className="intelli-solution-desc"
                                    style={{ ...styles.intelliSolutionDesc, display: 'block' }}
                                >
                                    <p>
                                        We follow a three-step approach to business excellence: educate, engage, and evaluate. We educate our associates on the latest process improvements, problem-solving tools, and methodologies, and engage them to apply the learnings in projects and business processes. We also evaluate the performance of delivery units annually and allow them to benchmark best practices both internally and externally.
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="row">
                    {/* Card 4 */}
                    <div className="col-sm-12 col-md-4 mb-4">
                        <div
                            className="intelli-solution-block"
                            style={styles.intelliSolutionBlock}
                            onClick={() => handleCardClick('card4')} // Toggle card4 content
                        >
                            <div
                                className="intelli-solution-image"
                                style={{
                                    ...styles.intelliSolutionImage,
                                    backgroundImage: `url(${backgroundImage4})`,
                                }}
                            />
                            <h3 style={styles.h3}>Our Approach to Business Excellence</h3>
                            {visibleContent.card4 && (
                                <div
                                    className="intelli-solution-desc"
                                    style={{ ...styles.intelliSolutionDesc, display: 'block' }}
                                >
                                    <p>
                                        We follow a three-step approach to business excellence: educate, engage, and evaluate. We educate our associates on the latest process improvements, problem-solving tools, and methodologies, and engage them to apply the learnings in projects and business processes. We also evaluate the performance of delivery units annually and allow them to benchmark best practices both internally and externally.
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Card 5 */}
                    <div className="col-sm-12 col-md-8 mb-4">
                        <div
                            className="intelli-solution-block"
                            style={styles.intelliSolutionBlock}
                            onClick={() => handleCardClick('card5')} // Toggle card5 content
                        >
                            <div
                                className="intelli-solution-image"
                                style={{
                                    ...styles.intelliSolutionImage,
                                    backgroundImage: `url(${backgroundImage5})`,
                                }}
                            />
                            <h3 style={styles.h3}>Quality Management System</h3>
                            {visibleContent.card5 && (
                                <div
                                    className="intelli-solution-desc"
                                    style={{ ...styles.intelliSolutionDesc, display: 'block' }}
                                >
                                    <p>
                                        We follow a three-step approach to business excellence: educate, engage, and evaluate. We educate our associates on the latest process improvements, problem-solving tools, and methodologies, and engage them to apply the learnings in projects and business processes. We also evaluate the performance of delivery units annually and allow them to benchmark best practices both internally and externally.
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Digitalimpactdeliverypage;
